<div class="call-to-action py-3">
    <div>Unknown Clinic</div>
</div>
  
<div class="inner-container">
        <p>We are sorry that we cannot find the clinic you are looking for.</p>
        <p>Please use the booking link on your clinics website.</p>
</div>
    
